/*
 * the LoginService class handles login requests
 * http://stackoverflow.com/questions/34755350/using-http-rest-apis-with-angular-2/34758630#34758630 (see accepted answer by Pardeep Jain)
 * http://stackoverflow.com/questions/37290672/passing-parameters-in-http-get-using-angular-2 (see accepted answer by Pardeep Jain)
 * https://angular.io/docs/ts/latest/guide/server-communication.html#!#error-handling
 * by ole fjarestad & jarand bjerkhaug
 */

import { Injectable } from '@angular/core';
import { Http, Headers, Request, RequestOptions, RequestMethod, Response } from '@angular/http';
import { CanActivate, Router }    from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { api } from './api';
import { AuthResponse } from './auth-response';


@Injectable()
export class UserAuthService implements CanActivate {

	private authUrl: string = api.base + '/authenticate';
        private forgotPassUrl: string = api.base + '/authenticate/forgot-password';
  	
  	constructor(
  		private http: Http,
  		private router: Router,
  	) { }

  	private getRequestOptions(options){
  		let headers = new Headers();
  		headers.append( 'Accept', 'application/json' );
  		options.headers = headers;

  		let requestOptions = new RequestOptions(options);

  		return requestOptions;
  	}

  	private handleError( error: Response ){
  		return Observable.throw( error );
  	}

  	/* authenticate, aka login */
    authenticate(username: string, password: string):Observable<AuthResponse> {

    	let body = {
			username: username,
			password: password,
			audience: 'Donna Web application',
		}

		let requestOptions = {
			method: RequestMethod.Post,
			url: this.authUrl,
			body: body,
      		withCredentials: true,
		}

		// just for debugging
		// let myRequest = new Request(this.getRequestOptions(requestOptions));

	    let authResponse$ = this.http
	                            .request( new Request(this.getRequestOptions(requestOptions)) )
	                            .map( (res: Response) => res.json() )
	                            .catch( this.handleError );

		return authResponse$;

    }

    isLoggedIn() {


  		let requestOptions = {
  			method: RequestMethod.Get,
  			url: api.base,
  			withCredentials: true,
  		}

  	    let tokenInfo$ = this.http
  	                            .request( new Request(this.getRequestOptions(requestOptions)) )
  	                            // .toPromise()
  	                            .map( (res: Response) => res.json() )
  	                            // .then( response => response.json() )
  	                            .catch( this.handleError );

  		return tokenInfo$;

    }

    getCurrentUser() {

    	if ( localStorage.getItem( 'donna-user-auth' ) !== null ) {
    		let user = JSON.parse( localStorage.getItem( 'donna-user-auth' ) );
    		return user;
    	} else {
    		return false;
    	}

    }

    getToken ( encoded: boolean = true ) {

    	// eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC9kb25uYS5zZW13YXkubmV0XC9hcGkiLCJhdWQiOiJEb25uYSBXZWIgYXBwbGljYXRpb24iLCJpYXQiOjE0OTc4NjMzNTUsImV4cCI6MTQ5ODQ2ODE1NSwidWlkIjoxfQ.EfvWW2zF5_cOJQj6cHg9mwtKCQVfs9KrQhU16SBY1qQ
    	let user = JSON.parse( localStorage.getItem( 'donna-user-auth' ) );

    	if ( user && user.token ) {

			var token: any = user.token;

			if ( encoded == false ) {
	    		token = atob( token ); // throws a console error "Failed to execute 'atob' on 'Window': The string to be decoded is not correctly encoded."
	    	}

	    	return token;

		} else {

			return false;

		}

    	// let token = JSON.parse( localStorage.getItem( 'donna-user-auth' ) ).token;

    }

    logout() {

		let requestOptions = {
			method: RequestMethod.Get,
			url: api.base + '/site/logout',
			body: {},
      		withCredentials: true,
		}

		// just for debugging
		// let myRequest = new Request(this.getRequestOptions(requestOptions));

	    let authResponse$ = this.http
	                            .request( new Request(this.getRequestOptions(requestOptions)) )
	                            .map( (res: Response) => res.json() )
	                            .catch( this.handleError );

		return authResponse$;

    	// localStorage.removeItem( 'donna-user-auth' ); // #RPT: might have to do some more stuff here?

    }

    /**
     * prevent users from accessing certain routes without being logged in
     * https://stackoverflow.com/questions/39566557/how-to-implement-canactivate-guard-in-angular2
     * https://stackoverflow.com/questions/38425461/angular2-canactivate-calling-async-function
     * https://angular.io/api/router/CanActivate
     * https://stackoverflow.com/questions/45888002/angular-4-cannot-subscribe-observable-value-from-canactivate-accessguard
     * https://www.google.no/search?q=angular+canactivate+subscribe&oq=angular+canactivate+subscribe&aqs=chrome..69i57.6839j0j7&sourceid=chrome&ie=UTF-8
     */
    canActivate(): Observable<boolean> | boolean {
    	return this.isLoggedIn().map( // the key here is to use map() (rxjs) instead of subscribe(), so we can return an Observable instead of a Subscription
    		(res) => {
    			if ( res.status == 200 ) {
    				return true;
    			} else {
    				this.router.navigate(['/login']);
    				return false;
    			}
    		},
    		(error) => {
    			this.router.navigate(['/login']);
    			return false;
    		}
    	);
	}

 generateResetPasswordLink(email: string):Observable<AuthResponse> {

    	let body = {
			email: email,
                        audience: 'Donna Web application',
		}
                let requestOptions = {
			method: RequestMethod.Post,
			url: this.forgotPassUrl,
			body: body,
      		withCredentials: true,
		}

		// just for debugging
		// let myRequest = new Request(this.getRequestOptions(requestOptions));

	    let authResponse$ = this.http
	                            .request( new Request(this.getRequestOptions(requestOptions)) )
	                            .map( (res: Response) => res.json() )
	                            .catch( this.handleError );

		return authResponse$;

    }
}



// WEBPACK FOOTER //
// ./src/app/user-auth.service.ts